var name = "@sparta.global.utilities/sparta-widget-loader-utility";
var version = "6.0.8";
var description = "";
var main = "dist/es6.js";
var scripts = {
	prepare: "npx sparta-package-manager build"
};
var targets = [
	"es5",
	"es6"
];
var assets = [
];
var keywords = [
];
var dependencies = {
};
var type = "module";
var gitHead = "141eb546b50aa28d8cd2e9ca62aeea92d24330bf";
var spk = "SPARTA";
var monorepo = "sparta_global_artifacts";
var ait = "69917";
var branchName = "develop-2025.05.0";
var packageJson = {
	name: name,
	version: version,
	description: description,
	main: main,
	scripts: scripts,
	targets: targets,
	assets: assets,
	keywords: keywords,
	dependencies: dependencies,
	type: type,
	gitHead: gitHead,
	spk: spk,
	monorepo: monorepo,
	ait: ait,
	branchName: branchName
};

// To cover for pre release versions
//const loaderVersion = version.split('-')[0];
const loaderVersion = packageJson.version;
(function () {
  window.sparta = window.sparta || {};
  sparta.widgetLoader = sparta.widgetLoader || {};
  if (sparta.widgetLoader[loaderVersion]) {
    console.log(`Widget lodaer version "${loaderVersion}" already loaded`);
    return;
  }
  const widgetDetails = {};
  const widgetInstances = {};
  const selectorIdMappings = {};
  const isDomId = c => !!document.getElementById(c);
  const addElId = el => el.id = el.id || `id${new Date().getTime()}`;
  const getNameVersionKey = (name, version) => `${name}-${version}`;
  const getContainerId = container => typeof container === 'string' ? isDomId(container) ? container : selectorIdMappings[container] : container.id;

  // CustomEvent polyfill. It's added here because Babel corejs polyfill doesn't include it and we will need it for V6 Sparta page loading a Sparta widget
  if (typeof window.CustomEvent !== 'function') {
    function CustomEvent(event, params) {
      params = params || {
        bubbles: false,
        cancelable: false,
        detail: undefined
      };
      var evt = document.createEvent('CustomEvent');
      evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
      return evt;
    }
    CustomEvent.prototype = window.Event.prototype;
    window.CustomEvent = CustomEvent;
  }
  function validateContainer(container) {
    if (typeof container === 'string') {
      const str = isDomId(container) ? `#${container}` : container;
      const selectorStr = str;
      const isSelector = str == container;
      if (document.querySelectorAll(str).length !== 1) {
        throw new Error('A single element is required as a container.');
      }
      container = document.querySelector(str);
      addElId(container);
      if (isSelector && !selectorIdMappings[selectorStr]) {
        selectorIdMappings[selectorStr] = container.id;
      }
      return container;
    }
    if (typeof container === 'object' && container.nodeType) {
      addElId(container);
      return container;
    }
    throw new Error('A valid DOM Id, selector or DOM Node must be passed as a container.');
  }
  function destroyWidget(id) {
    try {
      //remove inited modules / instances from bootstrap instance
      const {
        name,
        version
      } = widgetInstances[id];
      const spartaBootstrapUtilityInstance = window.spaWidgetParams[name][version].getBootstrapUtilityInstance();
      const {
        moduleInstances,
        initedModules
      } = spartaBootstrapUtilityInstance;
      for (const moduleClassName in moduleInstances) {
        moduleInstances[moduleClassName] = moduleInstances[moduleClassName].filter((m, i) => {
          if (m.id !== id && (!m.widgetInfo || m.widgetInfo.id !== id)) {
            return true;
          } else {
            // free up the memory
            if (moduleInstances[moduleClassName][i].destroy) {
              moduleInstances[moduleClassName][i].destroy();
            }
            delete moduleInstances[moduleClassName][i];
          }
        });
      }
      spartaBootstrapUtilityInstance.initedModules = initedModules.filter((m, i) => {
        if (m && m.module.widgetInfo) {
          if (m.module.widgetInfo.id !== id) {
            return true;
          } else {
            // free up the memory
            delete initedModules[i];
          }
        }
      });

      //clean up any sparta event handlers
      const spartaEventsUtility = widgetInstances[id].spartaEvents;
      if (spartaEventsUtility && spartaEventsUtility.unsubByEventNamePattern) {
        spartaEventsUtility.unsubByEventNamePattern(`_${id}`);
      }

      // call destroy on widget instance
      if (widgetInstances[id].destroy) {
        widgetInstances[id].destroy();
      }

      //empty the widget hosting container
      document.getElementById(id).innerHTML = '';

      // clear widget events from widget container
      widgetInstances[id].events.destroy();

      // remove widgetInstance
      delete widgetInstances[id];
    } catch (e) {
      console.error('Destroying widget instance failed for Widget.', id);
      return false;
    }
    return true;
  }
  function createWidgetEvents({
    container
  }) {
    return Object.create({
      triggeredEvents: {},
      subbedEvents: [],
      // creates and dispatches a native CustomEvent on our DispatcherElement
      pub(eventName, detail = {}) {
        if (!detail.widget || detail.widget.id === container.id) {
          this.triggeredEvents[eventName] = {
            detail
          };
          const evt = new CustomEvent(eventName, {
            detail
          });
          container.dispatchEvent(evt);
        }
      },
      // attaches an event listener to our DispatcherElement
      sub(eventName, callback, retroActive = false) {
        container.addEventListener(eventName, callback);
        if (retroActive && this.triggeredEvents[eventName]) {
          callback(this.triggeredEvents[eventName]);
        }
        this.subbedEvents.push({
          eventName,
          callback
        });
      },
      // allows subscriber to unsubscribe from event
      unsub(eventName, callback) {
        container.removeEventListener(eventName, callback);
      },
      // allows subscriber to listen to one instance of event and then unsub
      once(eventName, callback, retroActive = false) {
        if (retroActive && this.triggeredEvents[eventName]) {
          callback(this.triggeredEvents[eventName]);
        } else {
          const fn = e => {
            container.removeEventListener(eventName, fn);
            callback(e);
          };
          container.addEventListener(eventName, fn);
        }
      },
      // allows events to quickly be removed when destroying a widget.
      destroy() {
        this.subbedEvents.forEach(e => {
          try {
            let {
              eventName,
              callback
            } = e;
            container.removeEventListener(eventName, callback);
          } catch (error) {
            throw new Error(error);
          }
        });
      }
    });
  }
  function showLoading({
    container,
    spinner
  }) {
    container.classList.add(`sparta-widget-loader-v6`);
    container.classList.add('sparta-widget-loading'); // for ie11

    if (spinner) {
      container.classList.add('sparta-widget-loading-spinner');
    }
  }
  function hideLoading({
    container
  }) {
    const dataSpartaContainer = container.querySelector('[data-sparta-container]');
    if (dataSpartaContainer) {
      dataSpartaContainer.style.visibility = 'visible';
      dataSpartaContainer.classList.remove('sparta-widget-loading');
    }
    container.style.visibility = 'visible';
    container.classList.remove('sparta-widget-loading');
    container.classList.remove('sparta-widget-loading-spinner'); // for ie11
  }
  async function loadWidgetHtml({
    container,
    path,
    name,
    version,
    id,
    options,
    language = 'en',
    spinner = true
  }) {
    showLoading({
      container,
      spinner
    });
    const nameVersion = getNameVersionKey(name, version);
    widgetDetails[nameVersion] = widgetDetails[nameVersion] || {};
    let {
      loaderPromise
    } = widgetDetails[nameVersion];
    if (!loaderPromise) {
      let resolve, reject;
      loaderPromise = widgetDetails[nameVersion].loaderPromise = new Promise((res, rej) => {
        [resolve, reject] = [res, rej];
      });
      const xhr = new XMLHttpRequest();
      if (!options.withoutCredentials) {
        xhr.withCredentials = true;
      }
      const lang = !language || language.toLowerCase() === 'en' ? '' : `/${language.toLowerCase()}`;
      const widgetUrl = `${path}/spa/widgets/${name}/${version}${lang}/index.html`;
      xhr.open('GET', widgetUrl);
      xhr.onreadystatechange = function readyChange() {
        if (xhr.readyState !== 4) {
          return;
        }
        if (xhr.status < 200 || xhr.status >= 300) {
          if (options.onError) {
            options.onError({
              widget: {
                name,
                version,
                path,
                container
              }
            });
          }
          delete widgetDetails[nameVersion];
          reject({
            status: xhr.status,
            statusText: `Unable to load widget: ${widgetUrl} - ${xhr.statusText}`
          });
        } else {
          const widgetData = processWidgetHTML(xhr.responseText);
          resolve({
            widgetData
          });
        }
      };
      xhr.send();
    } else {
      console.log('Using cache widget details');
    }
    return loaderPromise;
  }
  function loadCSS({
    href,
    container,
    name,
    version,
    path,
    options
  }) {
    return new Promise((resolve, reject) => {
      const element = document.createElement('link');
      element.type = 'text/css';
      element.rel = 'stylesheet';
      element.onload = () => resolve(href);
      element.onerror = err => {
        if (options.onError) {
          options.onError({
            widget: {
              name,
              version,
              path,
              container
            },
            error: err
          });
        }
        reject(`Failed to load the widget css - ${href}. ${err}`);
      };
      element.href = href;
      document.head.appendChild(element);
    });
  }
  function loadScript({
    script,
    container,
    name,
    version,
    id,
    path,
    options
  }) {
    return new Promise((resolve, reject) => {
      const scriptTag = document.createElement('script');
      if (script.attrs) {
        for (const a in script.attrs) {
          scriptTag.setAttribute(a, script.attrs[a]);
        }
      }
      scriptTag.setAttribute('widget-name', name);
      scriptTag.setAttribute('widget-version', version);
      scriptTag.setAttribute('widget-id', id);
      if (script.text) {
        scriptTag.appendChild(document.createTextNode(script.text));
      } else {
        scriptTag.src = script.src;
        scriptTag.onload = () => resolve(true);
        scriptTag.onerror = err => {
          if (options.onError) {
            options.onError({
              widget: {
                name,
                version,
                path,
                container
              },
              error: err
            });
          }
          reject(`Failed to load the widget script - ${script.src}. ${err}`);
        };
      }
      container.appendChild(scriptTag);
      if (script.text) {
        resolve(true);
      }
    });
  }
  function loadWidgetScripts({
    name,
    version,
    id,
    container,
    widgetData,
    path,
    options
  }) {
    return new Promise((resolve, reject) => {
      const nameVersion = getNameVersionKey(name, version);
      if (widgetDetails[nameVersion].scriptsLoaded) {
        return resolve();
      }
      widgetData.scripts.reduce((cur, script) => cur.then(() => loadScript({
        script,
        container,
        name,
        version,
        id,
        path,
        options
      })).catch(e => {}), Promise.resolve()).then(() => {
        widgetDetails[nameVersion].scriptsLoaded = true;
        resolve();
      }).catch(error => {
        console.error('Loading widget scripts failed.');
        reject(error);
      });
    });
  }
  function loadWidgetCSS({
    name,
    version,
    widgetData,
    container,
    path,
    options
  }) {
    return new Promise((resolve, reject) => {
      const nameVersion = getNameVersionKey(name, version);
      if (widgetDetails[nameVersion].cssLoaded) {
        // we can now remove the loading spinner here - can emit an event to remove the spinner
        return resolve();
      }
      widgetData.css.reduce((cur, css) => cur.then(() => loadCSS({
        href: css.href,
        container,
        name,
        version,
        path,
        options
      })).catch(e => {}), Promise.resolve()).then(() => {
        widgetDetails[nameVersion].cssLoaded = true;
        resolve();
      }).catch(error => {
        console.error('Loading widget css failed.');
        reject(error);
      });
    });
  }
  async function renderMarkupAndloadAssets(widgetRequest, widgetResponse) {
    const {
      name,
      version,
      container,
      options,
      path
    } = widgetRequest;

    // response from widget api endpoint with assets (contents/urls)
    const {
      widgetData
    } = widgetResponse;
    container.innerHTML = widgetData.html;
    container.style.height = 'auto';
    container.style.backgroundImage = '';
    //add namespace
    container.querySelector(`[data-sparta-wrapper]`).classList.add(`${name}-${version.replace(/\./g, '-')}`);
    container.querySelector('[data-sparta-widget]').setAttribute('data-sparta-options', JSON.stringify(options));
    return Promise.all([loadWidgetCSS({
      name,
      version,
      widgetData,
      container,
      path,
      options
    }), loadWidgetScripts({
      name,
      version,
      container,
      widgetData,
      id: container.id,
      path,
      options
    })]);
  }
  function extendWidgetInstance({
    container,
    spartaBootstrapUtilityInstance
  }) {
    const {
      id
    } = container;
    const widgetClassName = container.querySelector('[data-component="module"]').getAttribute('data-init');
    const widgetModulesInstances = spartaBootstrapUtilityInstance.moduleInstances[widgetClassName];
    const widgetInstance = widgetModulesInstances.find(wi => wi.id === id);
    widgetInstance.events = widgetInstances[id].events; // can we just stick to events and not also widgetEvents or spartaEvents
    widgetInstance.hideLoading = widgetInstances[id].hideLoading;
    widgetInstances[id] = widgetInstance;
    return widgetInstance;
  }
  function initWidgetInstance({
    id,
    container
  }) {
    widgetInstances[id] = {};
    widgetInstances[id].events = createWidgetEvents({
      container
    });
    widgetInstances[id].hideLoading = () => {
      hideLoading({
        container
      });
    };
  }
  function initSingletonUtiiltyInitializers({
    id,
    singletonUtiiltiyInitializers
  }) {
    singletonUtiiltiyInitializers.forEach(initForWidgets => {
      try {
        initForWidgets({
          widgetId: id
        });
      } catch (e) {}
    });
  }
  async function createAndInitWidget({
    name,
    version,
    container,
    options = {},
    path
  }) {
    const spaWidget = window.spaWidgetParams[name][version];
    const spartaBootstrapUtilityInstance = spaWidget.getBootstrapUtilityInstance();
    const {
      id
    } = container;
    spaWidget[id] = {
      ...spaWidget
    }; // used by bootstrap utility

    initWidgetInstance({
      id,
      container
    });
    initSingletonUtiiltyInitializers({
      id,
      singletonUtiiltiyInitializers: spaWidget.singletonUtiiltiyInitializers || []
    });
    await spartaBootstrapUtilityInstance.init({
      name,
      version,
      id,
      options,
      loaderVersion,
      widgetApiEndpoint: path
    });
    return extendWidgetInstance({
      container,
      spartaBootstrapUtilityInstance
    });
  }
  function processWidgetHTML(widgetHTML) {
    const tempContainer = document.createElement('div');
    tempContainer.innerHTML = widgetHTML;
    const linkTags = tempContainer.querySelectorAll('link');
    const scriptTags = tempContainer.querySelectorAll('script');
    let css = [];
    let scripts = [];
    if (linkTags) {
      Array.prototype.forEach.call(linkTags, link => {
        css.push({
          href: link.href
        });
        link.parentNode.removeChild(link);
      });
    }
    if (scriptTags) {
      Array.prototype.forEach.call(scriptTags, script => {
        const attrs = {};
        Array.prototype.forEach.call(script.attributes, a => {
          attrs[a.name] = a.value;
        });
        const text = script.innerText || script.textContent;
        const {
          src
        } = script;
        scripts.push(src ? {
          src,
          attrs
        } : {
          text,
          attrs
        });
        script.parentNode.removeChild(script);
      });
    }
    const assetUrlsContainer = tempContainer.querySelector('#asset-urls-container');
    const assetUrlContent = assetUrlsContainer.innerText || assetUrlsContainer.textContent;
    const assetUrls = JSON.parse(assetUrlContent);
    assetUrlsContainer.parentNode.removeChild(assetUrlsContainer);

    //load widget css before other css
    css = assetUrls.css.map(href => {
      return {
        href
      };
    }).concat(css);

    //load widget scripts after other scripts
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    assetUrls.scripts.forEach(src => {
      if (isIE11) {
        //es5 or other js
        if (src.indexOf('-es6-') === -1) {
          scripts.push({
            src
          });
        }
      } else {
        //es6 or other js
        if (src.indexOf('-es5-') === -1) {
          scripts.push({
            src
          });
        }
      }
    });
    return {
      css,
      scripts,
      html: tempContainer.innerHTML
    };
  }
  sparta.widgetLoader[loaderVersion] = {
    load: async widgetRequest => {
      try {
        const {
          container,
          options = {}
        } = widgetRequest;
        const {
          id
        } = widgetRequest.container = validateContainer(container);
        const currentInstance = widgetInstances[id];
        if (currentInstance) {
          if (options.reuseInstance) {
            //publish event to all the modules of the widget that we are reusing the instance, they can react to the event as necessary
            widgetInstances[id].spartaEvents.pub(`REUSING_WIDGET_INSTANCE`, widgetInstances[id], {
              id
            });
            console.log('Reusing current widget instance');
            return;
          } else {
            destroyWidget(id);
          }
        }
        const widgetResponse = await loadWidgetHtml(widgetRequest);
        await renderMarkupAndloadAssets(widgetRequest, widgetResponse);
        await createAndInitWidget(widgetRequest);
        if (typeof options.onLoad === 'function') {
          try {
            options.onLoad(widgetInstances[id]);
          } catch (e) {
            console.error('Exception occurred in the onLoad callback');
          }
        }
      } catch (e) {
        console.error('Error in loading the widget', e);
        if (typeof widgetRequest.container !== 'string') {
          widgetRequest.container.innerHTML = '<p>Unable to load widget.</p>';
          hideLoading({
            container: widgetRequest.container
          });
        }
      }
    },
    destroy: container => {
      try {
        if (container) {
          const id = getContainerId(container);
          if (widgetInstances[id]) {
            return destroyWidget(id);
          }
        }
      } catch (e) {}
      return false;
    },
    getInstance: container => {
      try {
        if (container) {
          const id = getContainerId(container);
          return widgetInstances[id] || null;
        }
      } catch (e) {}
      return null;
    },
    refresh: ({
      container,
      options = {}
    }) => {
      //Do we really need this? Who uses it? They can very well call load with some flag like reuseInstance
      const {
        id
      } = validateContainer(container);
      if (widgetInstances[id]) {
        //publish event to all the modules of the widget that we are reusing the instance, they can react to the event as necessary
        widgetInstances[id].spartaEvents.pub('REFRESH_WIDGET', {
          data: options
        }, {
          id
        });
      } else {
        console.error("Widget doesn't exist");
      }
    }
  };
})();
var index = sparta.widgetLoader[loaderVersion];

export { index as default };
